import {DrawerProps} from '@mantine/core';
import {RecordForm} from '../forms/RecordForm.tsx';
import config from '../config';
import {
    PersonaFormValues,
    PersonaRecordFormProps,
} from '../types.ts';
import {PlatformDrawer} from '@flexinet/ui-components';

export const FormDrawer = (
    {
        record,
        handleSubmit,
        opened,
        onClose,
        ...rest
    }: DrawerProps & Omit<PersonaRecordFormProps, 'handleCancel'>) => {

    const title = record.id
        ? `Edit ${config.titles.singular}`
        : `New ${config.titles.singular}`;

    // Close on SUCCESSFUL submit, not on attempted submit (FNP-925).
    //
    // handleSubmit resolves to an async mutateAsync call. Firing onClose() on
    // the same tick closed the drawer regardless of outcome, so a server-side
    // rejection or network failure discarded everything the user had typed,
    // leaving only a toast. Awaiting means a rejection propagates and the
    // drawer stays open with the values intact.
    //
    // Validation errors were already safe: Formik does not call onSubmit when
    // the schema fails.
    const handleFormSubmit = async (values: PersonaFormValues) => {
        await handleSubmit(values);
        onClose();
    };

    return (
        <PlatformDrawer
            opened={opened}
            onClose={onClose}
            title={title}
            {...rest}
        >
            <RecordForm
                record={record}
                handleSubmit={handleFormSubmit}
                handleCancel={onClose}
            />
        </PlatformDrawer>
    );
};
